import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { Store } from '@ngrx/store';
import { selectLoggedInUser } from '@mkp/user/state-logged-in/selectors';
import { combineLatest, filter, map, take } from 'rxjs';
import { hasFullInformation } from './has-full-user-information.guard';

export const hasPartialUserInformationGuard = () => {
  const store = inject(Store);
  const router = inject(Router);

  return combineLatest([store.select(selectLoggedInUser)]).pipe(
    filter(([user]) => user !== undefined),
    map(([user]) => !hasFullInformation(user)),
    map((hasPartialInfo) => hasPartialInfo || router.parseUrl(AppConfig.routes.dashboard)),
    take(1)
  );
};
